import {
  GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_FAILED,
  GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_START,
  GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_SUCCESS
} from './types';

/** @param {Object} payload
 * @param {Number} payload.Type 0: OR; 1: AND
 * @param {Array} payload.ListProducts products list with properties: ProductId: string; VariantId: string; Threshold: number
 */
export const getBOPISFreeGiftAvailabilityStoresStart = (payload) => (
  {
    type: GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_START,
    payload
  }
);

export const getBOPISFreeGiftAvailabilityStoresSuccess = (payload) => (
  {
    type: GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_SUCCESS,
    payload
  }
);

export const getBOPISFreeGiftAvailabilityStoresFailed = (payload) => (
  {
    type: GET_BOPIS_FREE_GIFT_AVAILABILITY_STORES_FAILED,
    payload
  }
);